export function safeRedirect(target: string | undefined, fallback = '/'): string {
  if (!target) return fallback
  if (!target.startsWith('/') || target.startsWith('//') || target.startsWith('/\\'))
    return fallback
  return target
}
